<template>
  <li class="nav-item dropdown dropdown-user">
    <el-dropdown
        ref="dropdown"
        trigger="click"
        placement="right-start"
        popper-class="j-user-dropdown">
      <a class="nav-link dropdown-toggle dropdown-user-link">
        <div class="hd">
          <span class="avatar">
            <j-avatar
                v-if="isSimulation"
                :url="`/img/avatar/holder/robot.png`" />
            <j-avatar
                v-else
                :url="getUser.avatarUrl" />
          </span>
        </div>
      </a>
      <template #dropdown>
        <el-dropdown-menu
            class="kg">
          <el-dropdown-item
              class="fg d-flex d-flex-column">
            <div v-if="isSimulation"
                 class="robot"
                 v-html="$t('模擬登入中')" />
            <small :class="isSimulation ? `hj` : null"
                   class="w-100 cg999 d-inline-block"
                   v-html="$t('帳號名稱')" />
            <a class="w-100 d-flex justify-content-start align-items-center">
              <div class="jd">
                <icon-sax :hover="false"
                          class="ft-20 cgBase m-l-10"
                          type="security-safe" />
              </div>
              <div v-safe-html="getUser.name"
                    class="user-name m-l-10 m-r-8" />
            </a>
            <small class="w-100 cg999 d-inline-block"
                   v-html="$t('所在時區')" />
            <a class="w-100 d-flex justify-content-start align-items-center">
              <div class="jd">
                <icon-sax :hover="false"
                          class="ft-20 cgBase m-l-10"
                          type="clock" />
              </div>
              <div v-safe-html="getUser.church.timezone.name"
                   class="user-name m-l-10 m-r-8" />
            </a>

            <!-- 邀請碼 (由側欄功能列移入) -->
            <template v-if="getUser.church.invitation">
              <small class="w-100 cg999 d-inline-block"
                     v-html="$t('教會邀請碼')" />
              <a class="w-100 d-flex justify-content-start align-items-center">
                <div class="jd">
                  <icon-sax :hover="false"
                            class="ft-20 cgBase m-l-10"
                            type="key" />
                </div>
                <div v-safe-html="getUser.church.invitation"
                     class="user-name m-l-10 m-r-8" />
              </a>
            </template>
          </el-dropdown-item>

          <el-dropdown-item
              class="fg d-flex d-flex-column">

            <!-- UI版本 -->
            <small class="w-100 cg999 d-inline-block"
                   v-html="$t('UI版本')" />
            <a class="w-100 d-flex justify-content-start align-items-center">
              <div class="jd">
                <icon-sax :hover="false"
                          class="ft-20 cgBase m-l-10"
                          type="monitor" />
              </div>
              <div v-safe-html="getVersionUI"
                   class="user-name m-l-10 m-r-8" />
            </a>

            <!-- 系統版本 -->
            <small class="w-100 cg999 d-inline-block"
                   v-html="$t('服務版本')" />
            <a class="w-100 d-flex justify-content-start align-items-center">
              <div class="jd">
                <icon-sax :hover="false"
                          class="ft-20 cgBase m-l-10"
                          type="driver-2" />
              </div>
              <div v-safe-html="getVersionCore"
                   class="user-name m-l-10 m-r-8" />
            </a>

          </el-dropdown-item>


          <!-- 切換語系 (第二層飄出選單: 滑過向右飄出語言清單) -->
          <el-dropdown-item>
            <el-dropdown
                placement="right-start"
                trigger="hover"
                @command="setRegion">
              <a class="w-100 m-l-5 d-flex justify-content-between align-items-center"
                 @click.stop>
                <span class="d-flex align-items-center">
                  <div class="jd">
                    <icon-sax :hover="false"
                              class="ft-20 cgBase"
                              type="global" />
                  </div>
                  <span class="m-l-5 m-r-8"
                        v-safe-html="getCurrentRegion.value" />
                </span>
                <icon-sax :hover="false"
                          class="ft-16 cgBase"
                          type="arrow-right-1" />
              </a>
              <template #dropdown>
                <el-dropdown-menu class="kg">
                  <el-dropdown-item
                      v-for="j in getAllRegion"
                      :key="j.id"
                      :command="j.id">
                    <a class="m-l-5 d-flex justify-content-start align-items-center">
                      <country-flag :iso="j.id"
                                    :size="20" />
                      <span class="m-l-10 m-r-8"
                            v-safe-html="j.value" />
                      <icon-sax v-if="j.id === getCurrentRegion.id"
                                :hover="false"
                                class="ft-16 text-success"
                                type="check" />
                    </a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </el-dropdown-item>

          <!-- 切換主題 (由側欄功能列移入) -->
          <el-dropdown-item
              @click="setTheme(isDarkTheme ? EnumTheme.LIGHT : EnumTheme.DARK)">
            <a class="m-l-5 d-flex justify-content-start align-items-center">
              <div class="jd">
                <icon-sax :hover="false"
                          class="ft-20 cgBase"
                          :type="isDarkTheme ? `sun` : `moon`" />
              </div>
              <span v-safe-html="$t(isDarkTheme ? '淺色主題' : '深色主題')"
                    class="m-l-5 m-r-8" />
            </a>
          </el-dropdown-item>

          <el-dropdown-item
              @click="closeDropDown"
              v-if="!isSimulation">
            <router-link :to="{name: `AdminPersonal`}" class="m-l-5 d-flex justify-content-start align-items-center">
              <div class="jd">
                <icon-sax :hover="false"
                          class="ft-20 cgBase"
                          type="user-square" />
              </div>
              <span v-html="$t('個人資料')"
                    class="m-l-5 m-r-8" />
            </router-link>
          </el-dropdown-item>

          <el-dropdown-item
              @click="onBack"
              v-else>
            <a class="m-l-5 d-flex justify-content-start align-items-center">
              <div class="jd">
                <icon-sax :hover="false"
                          class="ft-20 cgBase"
                          type="shield-tick" />
              </div>
              <span v-html="$t('返回管理介面')"
                    class="m-l-5 m-r-8" />
            </a>
          </el-dropdown-item>

          <el-dropdown-item
              v-if="isHead"
              class="divider" />

          <el-dropdown-item
              @click="onFlushCache"
              v-if="isHead">
            <a class="m-l-5 d-flex justify-content-start align-items-center">
              <div class="jd">
                <icon-sax :hover="false"
                          class="ft-20 cgBase"
                          type="unlimited" />
              </div>
              <span v-html="$t('釋放快取')"
                    class="m-l-5 m-r-8" />
            </a>
          </el-dropdown-item>
          <el-dropdown-item
              class="divider" />
          <el-dropdown-item
              @click="logoutIntent">
            <a class="m-l-5 d-flex justify-content-start align-items-center">
              <div class="jd">
                <icon-sax :hover="false"
                          class="ft-20 cgBase"
                          type="logout" />
              </div>
              <span v-html="$t('登出系統')"
                    class="m-l-5 m-r-8" />
            </a>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </li>
</template>

<script setup>

import JAvatar from "@/component/Avatar.vue"
import IconSax from "@/component/IconSax.vue"
import CountryFlag from "@/component/CountryFlag.vue"

import {computed, ref} from "vue"

import {useUser} from "@/hook/useUser"

import {useIntent} from "@/hook/useIntent"

import {usePermission} from "@/hook/usePermission"

import {useSwalAlert} from "@/hook/useSwalAlert"

import {useI18n} from "vue-i18n"

import http from "@/api"

import {useSetting} from "@/hook/useSetting"
import {EnumTheme} from "@/enum/theme"
import {useRegion} from "@/hook/useRegion"
import {sprintf} from "sprintf-js";
import {useSimulation} from "@/hook/useSimulation";

/**
 * API（僅本元件使用 → 內聯實作，不另立 api/module）：重整權限 GET /api/admin/user/flush
 * 需指定 completion.done（即使是空函式）才會顯示成功 swal，沿用原模組設定
 */
const apiFlush = () =>
    http.get(`/api/admin/user/flush`, {}, {opts: {completion: {done: () => {}}}})

const {
  showHandler
} = useSwalAlert()

const {
  t
} = useI18n()

const {
  isDarkTheme,
  setTheme
} = useSetting()

const {
  getAllRegion,
  getCurrentRegion,
  setRegion
} = useRegion()

const {
  getUser
} = useUser()

const {
  isHead,
  isSimulation
} = usePermission()

const {
  logoutIntent
} = useIntent()

const {
  onBack
} = useSimulation()

const dropdown = ref()

/**
 * 手動 - 關閉 - 右上方 - 下拉選單
 */
const closeDropDown = () => dropdown.value.handleClose()

/**
 * 手動 - 釋放 - 緩存
 */
const onFlushCache = () => showHandler({
  subject: t('即將手動釋放快取'),
  text: t('請確認後執行'),
  completion: {
    //呼叫儲存回調
    success: async () => await apiFlush()
  }
})

/**
 * 取得UI版本
 * 需要重新啟動才生效
 */
const getVersionUI = computed(() => {

  const v = (__APP_VERSION__).split(".")
  const build = v.pop();
  const version = v.join(".")

  return sprintf(
      "%s (%s)",
      version,
      build
  )

})

/**
 * 取得系統版本
 */
const getVersionCore = computed(() => {
  return sprintf(
      "%s (%s)",
      getUser.value.software.version,
      getUser.value.software.build
  )
})

</script>

<style scoped lang="scss">
.hd {
  position: relative;
  .sts {
    width: 8px;
    height: 8px;
    background-color: #F00;
    position: absolute;
    bottom: -2px;
    right: -2px;
    z-index: 3;
    border-radius: 8px;
    &.active {
      background-color: #28c76f !important;
    }
  }
}
.kg {
  // 項目已變多 (帳號/時區/邀請碼/通訊/版本/語言/主題/個人資料/登出...),
  // 整體縮小行距與內距, 讓下拉不過長
  .el-dropdown-menu__item {
    padding-top: 3px !important;
    padding-bottom: 3px !important;
    line-height: 1.35;
    // 語系巢狀下拉觸發列文字色: 因非項目直接子 <a>, 拿不到 custom.scss 的 > a 亮色, 這裡補上
    // (淺色主題 #333; 深色主題見樣式尾端的 .dark-layout 覆寫)
    .el-dropdown {
      a, span {
        color: #333 !important;
      }
    }
    // 動作列 (語言/主題/個人資料/登出) 的直接子 <a> 移除 custom.scss:627 的 8px 上下外距,
    // 讓每一項間距與資訊段落一致 (統一約 6px)
    &:not(.fg) > a {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
    // 堆疊多列 label+value 的區塊 (帳號/通訊/版本等)
    // padding 0 + 每個 value(a) 統一 margin-bottom 6px, 使「區塊之間」與「區塊內配對之間」間距一致 (皆 6px)
    &.fg {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      small {
        margin-bottom: 0;
        line-height: 1.2;
      }
      > a {
        margin-top: 1px;
        margin-bottom: 6px;
      }
    }
    // 分隔線: 明確畫出線條做區塊區隔 (淺色; 深色見樣式尾端覆寫)
    &.divider {
      height: 0;
      min-height: 0;
      line-height: 0;
      margin: 6px 12px !important;
      padding: 0 !important;
      border-top: 1px solid rgba(0, 0, 0, 0.10);
    }
    .user-name {
      width: 100%;
      display : inline-block;
      overflow : hidden;
      text-overflow : ellipsis;
      white-space : nowrap;

    }
  }
}
// 深色主題覆寫
.dark-layout .kg .el-dropdown-menu__item {
  // 語系巢狀下拉觸發列文字對齊其他項目色
  .el-dropdown {
    a, span {
      color: #d0d2d6 !important;
    }
  }
  // 分隔線
  &.divider {
    border-top-color: rgba(255, 255, 255, 0.10) !important;

  }
}
</style>

<style lang="scss">
// 整個下拉區塊更明顯: 邊框 + 圓角 + 陰影, 讓整塊浮出、跟背景清楚分開
// (popper teleport 到 body, 需用非 scoped + 具名 popper-class 精準命中, 不影響其他 dropdown)
.el-dropdown__popper.j-user-dropdown {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.22) !important;

}
.dark-layout .el-dropdown__popper.j-user-dropdown {
  border-color: rgba(255, 255, 255, 0.16) !important;
  box-shadow: 0 14px 44px rgba(0, 0, 0, 0.6) !important;

}
</style>
